<template>
    <div class="wrapper">
      <header class="bg">
        <h2>UED-CDN</h2>
        <div class="logo-page"><img src="../assets/images/vue.png" /></div>
        <p>mzui</p>
      </header>
      <section>
        <file-list :fileList="fileList"></file-list>
      </section>
    </div>
  </template>

<script>
const ur = "https://uedcdn.zto.com/static/mzui";
const versions = [
  '3.9.4',
  '3.9.1',
  '3.8.2',
  '3.8.1',
  '3.8.0',
  '3.7.1',
  '3.6.0',
  '3.5.0'
]
export default {
  name: "index",
  data() {
    return {
      fileList: versions.map(v => ({
        label: v,
        linkList: [
          `${ur}/${v}/mzui.css`,
          `${ur}/${v}/mzui.min.js`
        ]
      }))
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/view/ListMzui.vue